import React, { useCallback, useEffect } from "react";
import { LoadingSpinner } from "../../../../shared/components/SpinnerLoading";
import { LoadingFlex } from "../../../login/pages/Login/styles";
import LoadingEditor from "../LoadingEditor";

import { Container } from "./styles";
import iconClose from "../../assets/close-icon.svg";

interface AutoCompleteProps {
  loading: boolean;
  dataSuggestions: string[];
  dataChip: string[];
  setDataChip: React.Dispatch<React.SetStateAction<string[]>>;
  handleAddChip: (chip: string) => void;
  onInside: boolean;
  setOnInside: React.Dispatch<React.SetStateAction<boolean>>;
  handleClose: () => void;
}

const AutoCompleteBox: React.FC<AutoCompleteProps> = ({
  loading,
  dataSuggestions,
  dataChip,
  setDataChip,
  handleAddChip,
  onInside,
  setOnInside,
  handleClose
}) => {
  return (
    <Container
      onMouseEnter={() => {
        setOnInside(true);
      }}
      onMouseLeave={() => {
        setOnInside(false);
      }}
    >
      <div className="wrapper-relative">
        {loading ? (
          <LoadingFlex>
            <LoadingSpinner />
          </LoadingFlex>
        ) : (
          <>
            {dataSuggestions.map((suggestion: string) => (
              <span
                style={{ cursor: "pointer" }}
                onClick={() => handleAddChip(suggestion)}
                className="span-label"
              >
                {suggestion}
              </span>
            ))}
          </>
        )}

        <div className="wrapper-absolute" onClick={handleClose}>
          <img src={iconClose} className="icon-close" alt="" />
        </div>
      </div>
    </Container>
  );
};

export default AutoCompleteBox;
